import { render, staticRenderFns } from "./PeoDetail.vue?vue&type=template&id=4755ceac&scoped=true&lang=html"
import script from "./PeoDetail.vue?vue&type=script&lang=js"
export * from "./PeoDetail.vue?vue&type=script&lang=js"
import style0 from "./PeoDetail.vue?vue&type=style&index=0&id=4755ceac&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4755ceac",
  null
  
)

export default component.exports